var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownVoteOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5834 12.6249L6.37504 17.8333M6.37504 17.8333L1.16671 12.6249M6.37504 17.8333L6.37504 5.33325C6.37504 4.22818 6.81403 3.16837 7.59543 2.38697C8.37683 1.60557 9.43664 1.16658 10.5417 1.16658L17.8334 1.16658",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownVoteOff);
export default __webpack_public_path__ + "static/media/down-vote-off.8914b7a783608ef289d3077e041bf118.svg";
export { ForwardRef as ReactComponent };